export interface ReviewCategory {
  id: number;
  name: string;
  reviewId: number;
}

export interface ReviewCategoryState {
  reviewCategoryMap: ReviewCategoryMap;
}

export type ReviewCategoryMap = {
  [key: number]: ReviewCategory;
}

/** Redux Types */

export const SET_REVIEW_CATEGORY = 'SET_REVIEW_CATEGORY';

interface setReviewCategoryAction {
  type: typeof SET_REVIEW_CATEGORY;
  payload: ReviewCategoryMap;
}

export type ReviewCategoryActionTypes = setReviewCategoryAction;
